// $('.nav-tabs-autoselect').each(function (){
//     let $activeTab = $(this).find('> .nav-item > .nav-link.active');
//     if($activeTab.length === 0){
//         bootstrap.Tab.getInstance($(this).find('.nav-item:first-child > .nav-link')).show()
//     }
// })

const systemsightFormConditions = require('/Framework/assets/js/cms-form-conditions')

$(".nav-tabs-wrap .nav-tabs[role='tablist']").each(function () {
    var that = this;

    var checkFormConditions = function (){
        let jLink = $(that).find('.nav-link.active');
        if(jLink.length && jLink.attr('href') && jLink.attr('href').indexOf('#') === 0) {
            systemsightFormConditions.checkInputs(
                $(jLink.attr('href'))
            )
        }
    }

    if(that.id){
        var currentTab = window.location.hash ? window.location.hash.substring(1) : window.sessionStorage.getItem(that.id);

        $(that).on('shown.bs.tab', function (e) {
            currentTab = e.target.hash.substr(1);
            //Prisimenam kokį paskutinį tab'ą turėjo atidaręs
            window.sessionStorage.setItem(that.id, currentTab)
            checkFormConditions();
        });

        if(currentTab && $(that).find("a[href='#"+currentTab+"']:visible").length){
            bootstrap.Tab.getOrCreateInstance(
                $(that).find("a[href='#"+currentTab+"']")[0]
            ).show()
        }else{
            if (!$(that).find('li > a.active').length) {
                bootstrap.Tab.getOrCreateInstance(
                    $(that).find("li > a:first-child")[0]
                ).show()
            }
        }
        checkFormConditions();

        $(that).find('.nav-link.deselectable').on('click', function (e) {
            var $this = $(this);
            if($this.hasClass('active')) {
                setTimeout(function () {
                    $this.removeClass('active show');
                    $($this.attr('href')).removeClass('show active');
                    window.sessionStorage.removeItem(that.id);
                }, 200);
            }
        });

        //Jei paspaudžiamas tab'as, kuris turi hash'ą (o ne nuorodą) - uždedam hash'ą į nuorodą
        $(that).find('a.nav-link[href^="#"]').click(function(event) {
            var location = window.location.href;
            var hashLoction = location.indexOf('#');
            if(hashLoction > -1){
                location = location.substring(0, hashLoction)
            }
            history.replaceState({}, "", location + $(this).attr('href'))
        });
    }
});